<script setup lang="ts">
/**
 * UI-kit component
 * Category: Overlays
 * Name: OverlayDefault
 */
import type { OverlayDefaultProps } from '@UI/Overlays/OverlayDefault/types/interfaces'

defineOptions({
  name: 'OverlayDefault',
})

withDefaults(defineProps<OverlayDefaultProps>(), {
  show: false,
})

const emit = defineEmits<{
  click: []
}>()

const handleClick = (): void => {
  emit('click')
}
</script>

<template>
  <Transition>
    <div
      v-if="show"
      class="def-overlay"
      @click.self="handleClick"
    >
      <slot />
    </div>
  </Transition>
</template>

<style scoped lang="scss" src="../styles/_overlay-default.scss" />
